module.exports = __webpack_public_path__ + "static/media/profile-img.650f0448.png";